//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import VueLottiePlayer from 'vue-lottie-player';

export default {
  name: 'base-lottie-player',
  components: {
    vLottiePlayer: VueLottiePlayer,
  },
  props: {
    path: {
      type: String,
      required: true,
    },
    name: {
      type: String,
    },
    loop: {
      type: Boolean,
    },
    animControl: {
      type: Function,
    },
    lottieClasses: {
      type: String,
      default: 'w-auto h-auto',
    },
    lottieStyles: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedName() {
      // eslint-disable-next-line no-underscore-dangle
      return this.name || `lottie_${this._uid}`;
    },
  },
};
